import React from 'react';
import { Link } from 'react-router-dom';
import ArticleCard from './ArticleCard';
import '../styles/Articles.css';

function Articles() {
  const articlesData = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "JavaScript",
      title: "Modern JavaScript Techniques You Should Know in 2023",
      excerpt: "Discover the`` latest JavaScript features and patterns that are revolutionizing web development today.",
      date: "July 15, 2023",
      readTime: "8 min read",
      link: "/articles/modern-javascript-techniques",
      featured: false
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "React",
      title: "Building Performant React Applications: A Deep Dive",
      excerpt: "Learn how to optimize your React apps for better performance and improved user experience.",
      date: "July 10, 2023",
      readTime: "12 min read",
      link: "/articles/building-performant-react-applications",
      featured: false
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "Python",
      title: "Python for Data Science: Essential Libraries and Tools",
      excerpt: "Explore the most powerful Python libraries that every data scientist should master in their toolkit.",
      date: "July 8, 2023",
      readTime: "9 min read",
      link: "/articles/python-for-data-science",
      featured: false
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "AI",
      title: "The Future of AI in Software Development",
      excerpt: "Exploring how artificial intelligence is transforming the way we build and maintain software applications.",
      date: "July 5, 2023",
      readTime: "15 min read",
      link: "/articles/future-of-ai-in-software-development",
      featured: true
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1598520106830-8c45c2035460?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=80",
      category: "Security",
      title: "Essential Cybersecurity Practices for Web Developers",
      excerpt: "Stay ahead of security threats with these proven strategies to protect your web applications.",
      date: "June 28, 2023",
      readTime: "10 min read",
      link: "/articles/essential-cybersecurity-practices",
      featured: false
    },
  ];

  return (
    <section id="articles" className="articles-section">
      <h2 className="section-title">Latest Articles</h2>
      <div className="article-grid">
        {articlesData.map(article => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
      
      <div className="more-articles">
        <Link to="/articles" className="btn btn-outline"><i className="fas fa-th-list"></i> View All Articles</Link>
      </div>
    </section>
  );
}

export default Articles;
